import { render, staticRenderFns } from "./provider-createnewevent.vue?vue&type=template&id=b6bcf7ce&scoped=true"
import script from "./provider-createnewevent.vue?vue&type=script&lang=js"
export * from "./provider-createnewevent.vue?vue&type=script&lang=js"
import style0 from "./provider-createnewevent.vue?vue&type=style&index=0&id=b6bcf7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bcf7ce",
  null
  
)

export default component.exports